import { Link, useRouterState } from '@tanstack/react-router';
import { MessageSquare, Users, CheckSquare, BarChart2, Settings, SlidersHorizontal, ExternalLink, LogOut } from 'lucide-react';
import { useStore } from '../../store/useStore';
import { ROUTE_SECTIONS, SETTINGS_ROUTE, getRouteSection } from '../../routes';

const NAV_ICONS = {
  messages: MessageSquare,
  customers: Users,
  tasks: CheckSquare,
  analytics: BarChart2,
  channels: SlidersHorizontal,
  settings: Settings,
};

const NAV_ITEMS = [
  { ...ROUTE_SECTIONS[0], icon: NAV_ICONS.messages },
  { ...ROUTE_SECTIONS[1], icon: NAV_ICONS.customers },
  { ...ROUTE_SECTIONS[2], icon: NAV_ICONS.tasks },
  { ...ROUTE_SECTIONS[3], icon: NAV_ICONS.analytics },
  { ...ROUTE_SECTIONS[4], icon: NAV_ICONS.channels },
];

export default function NavSidebar({ onLogout }) {
  const { currentUser, conversations, customerContacts, tasks, loadTasks, loadContacts, loadAnalytics } = useStore();
  const pathname = useRouterState({ select: state => state.location.pathname });
  const activeSection = getRouteSection(pathname);
  const unreadTotal = conversations.reduce((sum, conv) => sum + (conv.unread || 0), 0);

  const getBadge = (item) => {
    if (item.id === 'messages') return unreadTotal;
    if (item.id === 'customers') return customerContacts.length;
    if (item.id === 'tasks') return tasks.length;
    return item.badge || 0;
  };

  const handleClick = (item) => {
    if (item.id === 'tasks') {
      loadTasks();
    }
    if (item.id === 'customers') {
      loadContacts();
    }
    if (item.id === 'analytics') {
      loadAnalytics();
    }
  };

  return (
    <nav className="nav-sidebar">
      <div className="nav-logo">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M8 10h8M8 13h5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      </div>

      {NAV_ITEMS.map((item, i) => (
        <Link
          key={i}
          to={item.to}
          className={`nav-btn tooltip-wrap ${activeSection === item.id ? 'active' : ''}`}
          onClick={() => handleClick(item)}
        >
          <item.icon size={18} />
          {getBadge(item) > 0 && <span className="nav-badge">{getBadge(item)}</span>}
          <span className="nav-label">{item.label}</span>
          <span className="tooltip">{item.label}</span>
        </Link>
      ))}

      <div className="nav-sep" />

      <Link
        to={SETTINGS_ROUTE.to}
        className={`nav-btn tooltip-wrap ${activeSection === SETTINGS_ROUTE.id ? 'active' : ''}`}
      >
        <Settings size={18} />
        <span className="nav-label">{SETTINGS_ROUTE.label}</span>
        <span className="tooltip">{SETTINGS_ROUTE.label}</span>
      </Link>

      <div className="nav-user-card" title={currentUser.name}>
        <div className="nav-user-avatar">{currentUser.initials}</div>
        <div>
          <div className="nav-user-name">{currentUser.name}</div>
          <div className="nav-user-role">系统</div>
        </div>
      </div>

      <div className="nav-footer-actions">
        <a className="nav-footer-link" href={process.env.REACT_APP_ERP_URL || `${window.location.protocol}//${window.location.host.replace(/^seeme\./, 'erp.')}/`} title="返回 ERP">
          <ExternalLink size={14} />
          <span>返回 ERP</span>
        </a>
        <button className="nav-footer-link" type="button" onClick={onLogout} title="退出登录">
          <LogOut size={14} />
          <span>退出</span>
        </button>
      </div>
    </nav>
  );
}
